import { createGlobalStyle, css } from "styled-components";
import { theme as HVTheme } from "@repo/HVComponents";
import { CSS_COLORS } from "./Colors";

const cssCommon = css`
  * {
    box-sizing: border-box;
  }

  *::-webkit-scrollbar {
    width: 6px;
  }

  *::-webkit-scrollbar-thumb {
    width: 6px;
  }

  *::-webkit-scrollbar-track {
    width: 6px;
  }

  html,
  body {
    height: 100%;
    font-family: ${HVTheme.fontFamily};
    font-weight: 400;
    font-size: 16px;
    min-width: 320px;
    background-color: var(--surface);
    user-select: none;
  }

  #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .grid-item-small {
    .grid-item-left {
      width: 100%;
    }

    .widget-handle-bar,
    .grid-item-right {
      display: none;
    }
  }

  #ada-button-frame {
    display: none !important;
  }

  #time-interval {
    opacity: 0;
    position: absolute;
    top: 48px;
    right: 24px;
    display: flex;
    max-height: 28px;
    flex-direction: row-reverse;

    input {
      height: 28px !important;
      min-height: auto;
      background: none !important;
      border: 1px solid var(--hv-border-default) !important;
      border-radius: var(--hv-radius-xl);
      padding: var(--hv-spacing-1) var(--hv-spacing-1) var(--hv-spacing-1)
        var(--hv-spacing-3);
      font-weight: 400;
      font-size: 13px;
      line-height: var(--hv-lineheight-body-sm);
      letter-spacing: 0%;
    }

    & > div > div {
      position: relative;

      & > *:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        position: absolute;
        top: 4px;
        right: 4px;
      }
    }

    .select-box {
      border-radius: var(--hv-radius-xl);
      padding: var(--hv-spacing-1);
      padding-left: var(--hv-spacing-3);
      font-size: 13px;
      font-weight: 400;

      .select-icon {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .select-icon-remove,
      .select-icon-arrow {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg path {
          fill: var(--icon-emphasis);
        }
      }

      > div:first-child {
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: unset;
        text-overflow: unset;
        line-height: var(--hv-lineheight-body-sm);
        height: 9px;
        font-size: 13px;
        letter-spacing: 0%;
      }
    }

    .option-list {
      border-radius: 4px;
      top: 28px;
      box-shadow: 0 2px 2px rgb(0 0 0 / 20%);
      width: 100px;
    }
  }

  .widget-body:has(.grid-item-right:hover),
  .widget-body:has(#time-interval:hover) {
    #time-interval {
      opacity: 1;
    }
  }
`;

const cssReset = css`
  * {
    padding: 0;
    margin: 0;

    :disabled {
      cursor: not-allowed;
    }
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  font,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-style: inherit;
    font-weight: inherit;
  }

  b {
    font-weight: 700;
  }

  div {
    box-sizing: border-box;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  html {
    -webkit-text-size-adjust: none;
    -moz-text-size-adjust: none;
    -ms-text-size-adjust: none;
    text-size-adjust: none;
  }

  body {
    line-height: 1;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
    border: 0;
  }

  ul,
  ol,
  li {
    list-style: none;
  }

  ul::after {
    content: "";
    display: block;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  caption,
  legend {
    position: absolute;
    top: -9999px;
    left: -9999px;
    font-size: 0;
    line-height: 0;
  }

  input,
  select,
  textarea,
  button {
    vertical-align: middle;
    font-family: inherit;
    font-size: inherit;
    border-radius: 3px;
  }

  textarea {
    resize: none;
  }

  select,
  input {
    cursor: auto;
  }

  button {
    cursor: pointer;
    background-color: transparent;
    border: none;
  }

  input[type="text"],
  input[type="password"],
  input[type="tel"],
  input[type="email"] {
    box-sizing: border-box;
  }

  input[type="radio"],
  input[type="checkbox"] {
    cursor: pointer;
  }

  label {
    cursor: pointer;
  }

  iframe {
    transition: height ease 0.5s;
  }
`;

export const GlobalStyles = createGlobalStyle`
  ${({ theme }) => CSS_COLORS[theme.type]}
  ${cssReset}
  ${cssCommon}
`;

export const StandardScrollBarStyle = css`
  &::-webkit-scrollbar {
    display: block;
    width: 6px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--background-scroll-thumb);
    border: none;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    margin: 8px;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
`;

export const DashboardTreeNodeCommon = css<{ isNoGroup?: boolean }>`
  .sm-tree-treenode {
    border-left: 2px solid transparent;
    position: relative;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    height: 28px;
    color: var(--text-secondary-1);
    .sm-tree-indent {
      padding-left: 16px;
    }
    :hover {
      background-color: var(--mono-0-4-per);
      color: var(--text-primary);
    }
  }

  .sm-tree-treenode-selected {
    border-left-color: var(--orange-4);
    background-color: var(--mono-0-8-per);
    color: var(--text-primary);
    opacity: 0.8;
  }

  .sm-tree-node-content-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 2px 0 0 6px;
  }

  .tree-node-dashboard {
    padding-left: 50px;
    .title-text {
      width: 160px;
    }
  }
`;
